import type { DocPageContent } from '../docs-content'

const page = {
  order: 22,
  slug: 'troubleshooting',
  title: 'Solución de Problemas',
  description: 'Soluciones para problemas, espacio de trabajo, medios, WebGPU, IA y exportación.',
  category: 'Referencia',
  related: ['workspaces', 'export'],
  sections: [
    {
      title: 'Navegador y espacio de trabajo',
      blocks: [
        {
          kind: 'table',
          headers: ['Síntoma', 'Solución'],
          rows: [
            
            [
              'Permiso denegado',
              'Elige una carpeta normal que puedas editar, luego permite el acceso de lectura y escritura.',
            ],
            [
              'Pide reconectar al reabrir',
              'Elige **Reconectar** para la misma carpeta; si se movió, elige una carpeta diferente.',
            ],
          ],
        },
      ],
    },
    {
      title: 'Medios e importación',
      blocks: [
        {
          kind: 'table',
          headers: ['Síntoma', 'Solución'],
          rows: [
            [
              'Medios Faltantes',
              'Vuelve a vincular con **Conceder Acceso**, **Localizar**, **Localizar Carpeta** o **Explorar Otra Carpeta**.',
            ],
            [
              'Error de importación o códec no compatible',
              'Prueba con otro formato compatible, o transcodifica el archivo primero.',
            ],
            [
              'La importación desde URL falla',
              'Asegúrate de que el enlace apunta al archivo multimedia en sí, no a una página que lo incrusta.',
            ],
            [
              'Vistas previas o formas de onda obsoletas',
              'Regenera miniaturas o proxies, o limpia la caché del proyecto en la configuración de Almacenamiento.',
            ],
          ],
        },
        {
          kind: 'note',
          tone: 'warning',
          text: 'Usa **Trabajar Sin Conexión** solo cuando tengas la intención de volver a vincular los archivos más tarde — los clips permanecen como referencias rotas hasta entonces.',
        },
      ],
    },
    {
      title: 'WebGPU e IA local',
      blocks: [
        {
          kind: 'table',
          headers: ['Síntoma', 'Solución'],
          rows: [
            [
              'Efectos, scopes o IA no disponibles',
              'Actualiza los controladores de la GPU y mantén la aceleración por hardware activada.',
            ],
            [
              'La descarga de un modelo es lenta o falla',
              'Mantén la pestaña abierta, reintenta con una conexión estable y borra la **Caché de Modelos de IA Local** si la descarga está corrupta.',
            ],
            ['Sin memoria durante el trabajo de IA', 'Usa **Descargar Modelos Locales** para liberar entornos de ejecución.'],
            ['Importación de LUT bloqueada', 'La importación de LUT (.cube) requiere un sistema actualizado.'],
          ],
        },
      ],
    },
    {
      title: 'Exportación',
      blocks: [
        {
          kind: 'table',
          headers: ['Síntoma', 'Solución'],
          rows: [
            [
              'Códec no disponible en la comprobación previa',
              'Elige otro códec o formato, o reduce la resolución o calidad.',
            ],
            [
              'Exportación por worker no disponible',
              'Mantén la pestaña enfocada y evita interacciones pesadas; reemplazar elementos de imagen animada con clips de vídeo puede ayudar.',
            ],
            [
              'Exportación grande o lenta',
              'Exporta un rango de entrada/salida más corto, reduce la resolución o calidad y libera espacio en disco primero.',
            ],
            [
              'La exportación no se inicia',
              'Resuelve cualquier advertencia de pre-vuelo que bloquee, luego prueba con un rango corto para confirmar que el pipeline funciona.',
            ],
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page